import { colors } from 'globalStyles'

export const pencilIconStyle = {
  width: '20px',
  height: '20px',
}

export const tableHeaderStyle = {
  display: 'table-cell',
  verticalAlign: 'middle',
  width: '50px',
}

export const tableContentStyle = {
  fontWeight: '600px',
  fontStyle: 'bold',
}

export const tableSubContentStyle = {
  color: colors.grey,
}

export const houseBuildingIconStyle = {
  width: '25px',
  height: '20px',
}

export const penToSquareIconStyle = {
  width: '25px',
  height: '25px',
}

export const buttonStyle = {
  fontSize: '14px',
  textAlign: 'left',
}

export const styledDiv = {
  display: 'table',
  width: '100%',
  marginTop: '8px',
}

export const styledBaseDiv = {
  display: 'flex',
  marginTop: '16px',
  width: '100%',
}

export const styledSubDiv = {
  display: 'table-cell',
  width: '50px',
}
